import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonReligiousCultsCrumbs } from 'civil-status/constants/place';
import { useParams } from 'react-router-dom';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformResponse } from 'civil-status/utils/place';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';
import FormPlace from 'civil-status/components/place/form';

const ReligiousCultsDetailPage = (): React.ReactElement => {
  const params = useParams();

  const [religiousCultsData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/${DomainType.ReligiousCults}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = religiousCultsData.data as PlaceForm;

  return (
    <Fragment>
      <Breadcrumbs
        items={[...CommonReligiousCultsCrumbs, { name: 'Visualizza culto religioso' }]}
      />
      {religiousCultsData.isLoading ||
      religiousCultsData.pristine ||
      religiousCultsData.error ? undefined : (
        <FormPlace
          title="Visualizza culto religioso"
          disabled
          initialValues={values}
          isReligiousCults
        />
      )}
    </Fragment>
  );
};

ReligiousCultsDetailPage.displayName = 'Death Religious Cults detail page component';

export default ReligiousCultsDetailPage;
